import * as React from "react";
import {
  DashboardSectionContainer,
  setInitialMonthsYears,
  setFormattedMonthDataRanked,
} from "../../../libs/commission_calculator_dashboard";
import * as moment from "moment";
import { ChartHeader } from "./ChartHeader";
import { DateRange } from "./DateRange";
import Loader from "../../core/Loader";
import { QuotaAvgDashboardSection } from "./QuotaAvgDashboardSection";
import { useState, useEffect } from "react";
import { getCommissionAverages } from "../../../libs/commission_calculator";
import { toast } from "../../../utils";
import * as Sentry from "@sentry/browser";

interface IProps {
  commissionsAll?: any;
}

export const DashboardBarRankSection = ({ commissionsAll }: IProps) => {
  const [loadingMonths, setLoadingMonths] = useState(true);

  const [monthSelectedStart, setMonthSelectedStart] = useState(
    moment()
      .subtract(1, "month")
      .toDate()
  );

  const [monthSelectedEnd, setMonthSelectedEnd] = useState(moment().toDate());

  const [yearSelected, setYearSelected] = useState(null);

  const [monthData, setMonthData] = useState([]);

  const [monthTeamData, setMonthTeamData] = useState(null);

  const [yearOptions, setYearOptions] = useState(null);

  const [coreAverages, setCoreAverages] = useState(null);

  // If value for commissionsAll changes (this should only happen during initial load),
  // Then set the intial month start and end and set the selected year (based on latest commission)
  useEffect(() => {
    if (commissionsAll) {
      const commissionsSet = [...commissionsAll];
      if (commissionsSet) {
        setInitialMonthsYears({
          commissionsSet,
          setMonthSelectedStart,
          setMonthSelectedEnd,
          setYearOptions,
          setYearSelected,
        });
      }
    }
  }, [commissionsAll]);

  // If start and end dates change, then set months data after formatting for bar graph
  useEffect(() => {
    setLoadingMonths(true);
    setCoreAverages(null);
    setMonthData([]);
    if (
      commissionsAll &&
      Array.isArray(commissionsAll) &&
      monthSelectedStart &&
      monthSelectedEnd
    ) {
      getCommissionAverages(
        moment(monthSelectedStart).format(),
        moment(monthSelectedEnd).format()
      )
        .then(resp => {
          if (resp && resp["quota_average"] && resp["quota_average"] !== null) {
            setCoreAverages(resp);
          }
          setLoadingMonths(false);
        })
        .catch(e => {
          setLoadingMonths(false);
          toast.error("Error retrieving averages");
          Sentry.captureException(e);
        });
    }
  }, [monthSelectedStart, monthSelectedEnd, commissionsAll]);

  // If core averages changes then set month data
  useEffect(() => {
    if (
      coreAverages &&
      commissionsAll &&
      monthSelectedStart &&
      monthSelectedEnd
    ) {
      setFormattedMonthDataRanked({
        commissionsAll,
        monthSelectedStart,
        monthSelectedEnd,
        setLoadingMonths,
        setMonthData,
        setMonthTeamData,
        coreAverages,
      });
    }
  }, [coreAverages, commissionsAll, monthSelectedStart, monthSelectedEnd]);

  return (
    <DashboardSectionContainer>
      <ChartHeader title={`Quota Avg Ranking`}>
        <DateRange
          monthSelectedStart={monthSelectedStart}
          setMonthSelectedStart={setMonthSelectedStart}
          monthSelectedEnd={monthSelectedEnd}
          setMonthSelectedEnd={setMonthSelectedEnd}
        />
      </ChartHeader>
      {loadingMonths ? (
        <Loader />
      ) : monthData.length > 0 && monthTeamData.length > 0 ? (
        <QuotaAvgDashboardSection
          dataTeamBar={monthTeamData}
          dataBar={monthData}
          collapsible={true}
        />
      ) : (
        <div>No data to display</div>
      )}
    </DashboardSectionContainer>
  );
};



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/dashboard/DashboardBarRankSection.tsx